module.exports = __webpack_public_path__ + "static/media/USBCharger.df49fc28.svg";